import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions/project';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import DataTable from 'react-data-table-component';
import Clear from '@material-ui/icons/Clear';
import { green } from '@material-ui/core/colors';
import { grey } from '@material-ui/core/colors';
import { blue } from '@material-ui/core/colors';
import BackspaceIcon from '@material-ui/icons/Backspace';
import {BuyerMapEd} from '../components/edComponents';
import {BuyerMapEdEnglish} from '../components/edComponents';
import {EdModal} from '../components/edComponents';
import Slide from '@material-ui/core/Slide';
import {Insights} from '../components';
import {ButtonDeleteChart} from '../components';
import SchoolIcon from '@material-ui/icons/School';
import {ChangeChartTitle} from '../components';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';



const customStyles = {
    headRow: {
        style: {
            border: 'none',
        },
    },
    headCells: {
        style: {
            color: '#202124',
            fontSize: '14px',
            justifyContent: "center",
        },
    },
    rows: {
        highlightOnHoverStyle: {
        },
    },
    pagination: {
        style: {
            border: 'none',
        },
    },
    style: {
      backgroundColor: 'green'
    },
    rows: {
      style: {
        border: '4px',
      }
    },
};



const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    form: {
        '& > *': {
            margin: theme.spacing(1),
            width: '100%',
        },
    },
    buttonmodal: {
      'margin-right': '15px',
    },
    table: {  
      width: 1100
    },
    head: {
      display: 'flex',
    },
    h1: {
      display: 'inline'
    },
    Button: {
      'margin-bottom': 15,
      'margin-top': 15
    },
    TwoButton: {
      display: 'flex',
      'justify-content': 'space-between'
    },
    Cell: {
      backgroundColor: '#ecf4f7',
      width: '100%',
      height: '100%',
      borderRadius: '15px',
      border: '5px solid white',
      display: 'flex',
      justifyContent: 'center',
      'whiteSpace': 'unset',
    },
    Clear: {
      marginTop: '7px'
    },
    Tooltip: {
      maxWidth: 500,
      fontSize: '16px'
    }


}));

function BuyerMapDetail({updateChart, deleteBuyerMap, selected, getDetailChart, match: {params: {projectId, chartId}}}) {
    React.useEffect(() => {
        getDetailChart(projectId, chartId)
    }, [projectId, chartId]);

    const Cell = ({done, onClick, description}) => {
        switch (done) {
            case 'red':
                return (
                  <Tooltip
                    title={description == null ? "Фокус Алого океана" : description}
                    TransitionComponent={Zoom}
                    interactive
                    placement="top"
                    arrow
                    classes={{ tooltip: classes.Tooltip }}>
                    <div
                      className={classes.Cell}
                      onClick={onClick}>
                      <Clear
                        className={classes.Clear}
                        color="secondary"
                        />
                    </div>
                  </Tooltip>

                )
            case 'green':
                return (
                  <Tooltip
                    title={description == null ? "Фокус Голубого океана" : description}
                    TransitionComponent={Zoom}
                    interactive
                    placement="top"
                    arrow
                    classes={{ tooltip: classes.Tooltip }}>
                    <div
                      className={classes.Cell}
                      onClick={onClick}>
                      <Clear
                        className={classes.Clear}
                        style={{ color: blue[500] }}
                        />
                      </div>
                  </Tooltip>
                  )
            case 'black':
                return (
                  <Tooltip
                    title={description == null ? "Боль клиента" : description}
                    TransitionComponent={Zoom}
                    interactive
                    placement="top"
                    arrow
                    classes={{ tooltip: classes.Tooltip }}>
                    <div
                      className={classes.Cell}
                      onClick={onClick}>
                      <Clear
                        className={classes.Clear}
                        style={{ color: grey[900] }}
                        onClick={onClick}/>
                      </div>
                    </Tooltip>
                  )
            case 'delet':
                return (
                  <div
                    className={classes.Cell}
                    onClick={onClick}>
                    <BackspaceIcon
                      className={classes.Clear}
                      style={{ color: '#ff3d00' }}
                      onClick={onClick}/>
                </div>
              )
            default:
                return (
                <div
                  className={classes.Cell}
                  onClick={onClick}>
                </div>
                )
        }
    };

    const [open, setOpen] = React.useState(false);
    const [openUpdate, setOpenUpdate] = React.useState(false);
    const [openUpdateRow, setOpenUpdateRow] = React.useState(false);
    const [rowKeys, setRowKeys] = React.useState({
      keys: null
    })
    const [cellKeys, setCellKeys] = React.useState(null)
    const classes = useStyles();

    const [values, setValues] = React.useState({
        title: '',
        cell: null,
        rowTitle: null,
        description: null,
        data: [],
    });

    React.useEffect(
        () => {
            if (!selected) {
                return
            }
            setValues({...values, data: selected.data});
        }, [selected]
    );

    if (!selected) {
        return (
            <div>
                Not Found
            </div>
        )
    }

    const handleUpdateClick = () => event => {
        const newData = [];
        console.log('values',values)
        console.log('values',selected)
        for (const row of values.data) {

            newData.push(row.title === values.rowTitle
                ? {
                    ...row,
                    [values.cell]: values.color === null ? row[values.cell] : values.color,
                    [values.cell + 'Description']: values.description === null ? row[values.cell + 'Description'] : values.description,
                  }
                : row
            )

        }
        newData.forEach((item, i) => {
          item['id'] = i
        });

        setValues({...values, data: newData});
        updateChart(projectId, chartId, {...selected, data: newData});
        setOpenUpdate(false);
        setValues({
            ...values, description: null, color: null
        });

    };

    const handleUpdateCellDelete = (val) => event => {
        const newData = [];
        // console.log('values',values,val )
        for (const row of values.data) {

            newData.push(row.title === values.rowTitle
                ? {...row, [values.cell]: val}
                : row
            )

        }
        newData.forEach((item, i) => {
          item['id'] = i
        });
        setValues({...values, data: newData});
        updateChart(projectId, chartId, {...selected, data: newData});
        setOpenUpdate(false);

    };

    const handleOpenUpdateClick = (rowTitle, cell) => event => {

        // // console.log('handleOpenUpdateClick',selected.data, rowTitle, cell)
        const rowId = []
        selected.data.forEach((item, i) => {
          // // console.log(rowTitle, item['title'], item['title'] === rowTitle, i)
          if (item['title'] === rowTitle) {
            rowId.push(i)
          }
        });

        // // console.log('rowId',rowId, ...rowId)

        setRowKeys(...rowId)
        setValues({...values, rowTitle, cell});
        setCellKeys(cell)
        setOpenUpdate(true);

    };



    const columns = [
        {
            name: 'Title',
            selector: 'title',
            style: { 'whiteSpace': 'unset', width: "150px" },
            cell: (row) => <div
                            style = {{ 'whiteSpace': 'initial' }}
                            onClick={() => clickOpenUpdateRow(row)}
                            >
                              {row.title}
                            </div>
        },
        {
            name: 'Productivity',
            ignoreRowClick: true,
            cell: (row) =>
                  <Cell
                      onClick={handleOpenUpdateClick(row.title,   'productivity', )}
                      done={row.productivity}
                      description={row.productivityDescription}
                  />
        },
        {
            name: 'Simplicity',
            ignoreRowClick: true,
            cell: (row) => <Cell onClick={handleOpenUpdateClick(row.title, 'simplicity')}
                                 done={row.simplicity}
                                 description={row.simplicityDescription}/>

        },
        {
            name: 'Convenience',
            ignoreRowClick: true,
            cell: (row) => <Cell onClick={handleOpenUpdateClick(row.title, 'convenience')}
                                 done={row.convenience}
                                 description={row.convenienceDescription}/>

        },
        {
            name: 'Risk Reduction',
            ignoreRowClick: true,
            cell: (row) => <Cell onClick={handleOpenUpdateClick(row.title, 'riskReduction')}
                                 done={row.riskReduction}
                                 description={row.riskReductionDescription}/>
        },
        {
            name: 'Fun & Image',
            ignoreRowClick: true,

            cell: (row) => <Cell onClick={handleOpenUpdateClick(row.title, 'funAndImage')}
                                 done={row.funAndImage}
                                 description={row.funAndImageDescription}/>
        },
        {
            name: 'Environmental Friendliness',
            ignoreRowClick: true,

            cell: (row) => <Cell onClick={handleOpenUpdateClick(row.title, 'environmentalFriendliness')}
                                 done={row.environmentalFriendliness}
                                 description={row.environmentalFriendlinessDescription}/>
        },
    ];


    const handleChange = name => event => {
        setValues({...values, [name]: event.target.value});
    };

    const handleClick = event => {
        const newData = [...values.data, {
                id: selected.data.length,
                title: values.title,
                productivity: null,
                simplicity: null,
                convenience: null,
                risk_reduction: null,
                fun_and_image: null,
                environmental_friendliness: null,
            }
            ];
        newData.forEach((item, i) => {
          item['id'] = i
        });
        setValues({
            ...values, data: newData
        });
        updateChart(projectId, chartId, {...selected, data: newData});
        setOpen(false);
        setValues({
            title: '',
        });

    };


    const handleClickDelete = event => {
        deleteBuyerMap(projectId, chartId);
    };

    const clickOpenUpdateRow = (o) => {
      setOpenUpdateRow(true)
      setRowKeys(o.id)

      // // console.log(rowKeys)

    }

    const handleClickRowUpdate = () => {
      const newData = {
        'id': selected.data[rowKeys].id,
        'title': values.title,
        'productivity': selected.data[rowKeys].productivity,
        'simplicity': selected.data[rowKeys].simplicity,
        'convenience': selected.data[rowKeys].convenience,
        'riskReduction': selected.data[rowKeys].riskReduction,
        'funAndImage': selected.data[rowKeys].funAndImage,
        'environmentalFriendliness': selected.data[rowKeys].environmentalFriendliness
      }
      selected.data[rowKeys] = newData
      // console.log([...selected.data][rowKeys])

      updateChart(projectId, chartId, {...selected, data: selected.data})
      setOpenUpdateRow(false)
      setValues({
        title: ''
      })
    }

    const RowDelete = event => {

      const newData = [...selected.data]

      newData.splice(event,1)

      setValues({data: newData})
      updateChart(projectId, chartId, {...selected, data: newData})
      setOpenUpdateRow(false)
    }

    return (
        <>
        <div
          className={classes.head}>
          <ChangeChartTitle
            selected={selected}
            projectId={projectId}
            chartId={chartId}
            title={<h1
              className={classes.h1}>Buyer Map | {selected.title} </h1>}/>
          <EdModal
            TextRu={BuyerMapEd}
            TextEng={BuyerMapEdEnglish}/>
        </div>

        <Button
          className={classes.Button}
          onClick={() => setOpen(true)}
          variant="contained" color="primary"
          style={{
            background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7'}}>
            Add row
        </Button>

        <DataTable
            noHeader={true}
            className={classes.table}
            columns={columns}
            data={values.data}
            customStyles={customStyles}
            highlightOnHover
            pointerOnHover
            onRowClicked={clickOpenUpdateRow}
        />

        <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            className={classes.modal}
            open={open}
            onClose={() => setOpen(false)}
        >
            <div className={classes.paper}>
                <h2 id="simple-modal-title">Add Row</h2>
                <form
                    className={classes.form}
                    noValidate autoComplete="off">
                    <TextField
                        id="title"
                        label="Title"
                        value={values.title} onChange={handleChange('title')}/>
                </form>
                <br/>
                <Button
                    variant="contained"
                    color="primary"
                    style={{
                      background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7'}}
                    onClick={handleClick}>

                    Ok
                </Button>
            </div>
        </Modal>
        <Modal
            aria-labelledby="update-modal-title"
            aria-describedby="update-modal-description"
            className={classes.modal}
            open={openUpdate}
            onClose={() => setOpenUpdate(false)}
        >
          {selected.data[rowKeys] && <>
              <div className={classes.paper}>
                  <h2 id="simple-modal-title">
                    Update square
                    <Button
                        className={classes.buttonmodaldelete}
                        onClick={handleUpdateCellDelete('delete')}>
                          <BackspaceIcon
                            className={classes.buttonmodaldelete}
                          />
                    </Button>
                  </h2>

                  <FormControl component="fieldset">
                      <RadioGroup aria-label="gender" name="gender1" onChange={handleChange('color')}>
                        <FormControlLabel
                          value="green"
                          control={<Radio />}
                          label="Blue" />
                        <FormControlLabel value="red" control={<Radio />} label="Red" />
                        <FormControlLabel value="black" control={<Radio />} label="Black" />
                      </RadioGroup>
                  </FormControl>
                  <TextField
                      id="description"
                      label="description"
                      value={values.description}
                      defaultValue={selected.data[rowKeys][cellKeys+'Description']}
                      onChange={handleChange('description')}/>
                    <div>
                      <Button
                        variant="contained"
                        onClick={handleUpdateClick()}>
                        update
                      </Button>
                    </div>


              </div>
            </>
          }
        </Modal>




        <Insights
          selected={selected}
          projectId={projectId}
          chartId={chartId}
        />

        <Modal
            aria-labelledby="update-modal-title"
            aria-describedby="update-modal-description"
            className={classes.modal}
            open={openUpdateRow}
            onClose={() => setOpenUpdateRow(false)}
        >
          <Slide direction="up" in={openUpdateRow} mountOnEnter unmountOnExit>
            <div className={classes.paper}>
              {selected.data[rowKeys] && <>
                  <form
                      className={classes.form}
                      noValidate autoComplete="off">
                      <TextField
                          id="title"
                          label="Title"
                          onChange={handleChange('title')}
                          defaultValue={selected.data[rowKeys].title}/>
                  </form>
                  <br/>
                  <div
                    className={classes.TwoButton}>
                    <Button
                        className={classes.Button}
                        variant="contained"
                        color="primary"
                        onClick={handleClickRowUpdate}>
                        update
                    </Button>
                    <Button
                      className={classes.Button}
                      onClick={() => RowDelete(rowKeys)}
                      variant="contained"
                      color="secondary">
                        Delete row
                    </Button>
                  </div>

              </>}
            </div>
          </Slide>
        </Modal>

      </>
    )
}

const mapStateToProps = state => state.charts;
const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(
    mapStateToProps, mapDispatchToProps,
)(BuyerMapDetail)
